import { ExecutionStatuses } from "../constants/execution-statuses";

export class Execution {
  constructor(
    id,
    name,
    description,
    organization,
    resources,
    progress,
    status,
    type,
    taskType,
    source,
    triggeredBy,
    logFileKey,

    input = {},
    output = {},
    datasetInfo = {},
    trainingExecutionInfo = {},
    sampleFileInfo = {},
    errors = [],

    appId,
    datasetId,
    userId,
    startedAt = null,
    createdAt = null,
    updatedAt = null,
    terminatedAt = null
  ) {
    /** @type {string} */
    this.id = id;
    /** @type {string} */
    this.name = name;
    /** @type {string} */
    this.description = description;
    /** @type {string} */
    this.organization = organization;
    /** @type {string} */
    this.resources = resources;
    /** @type {string | number} */
    this.progress = progress;
    /** @type {number} */
    this.status = status;
    /** @type {string} */
    this.type = type;
    /** @type {string} */
    this.taskType = taskType;
    /** @type {string} */
    this.source = source;
    /** @type {string} */
    this.triggeredBy = triggeredBy;
    /** @type {string} */
    this.logFileKey = logFileKey;
    /** @type {Object} */
    this.input = input;
    /** @type {Object} */
    this.output = output;
    /** @type {Object} */
    this.datasetInfo = datasetInfo;
    /** @type {Object} */
    this.trainingExecutionInfo = trainingExecutionInfo;
    /** @type {Object} */
    this.sampleFileInfo = sampleFileInfo;
    /** @type {string[]} */
    this.errors = errors;
    /** @type {string} */
    this.appId = appId;
    /** @type {string} */
    this.datasetId = datasetId;
    /** @type {string} */
    this.userId = userId;
    /** @type {Date} */
    this.startedAt = new Date(startedAt);
    /** @type {Date} */
    this.createdAt = new Date(createdAt);
    /** @type {Date} */
    this.updatedAt = new Date(updatedAt);
    /** @type {Date} */
    this.terminatedAt = new Date(terminatedAt);
  }

  /**
   *
   * @returns {boolean}
   */
  hasErrors() {
    return this.errors.length > 0;
  }

  /**
   * The errors in the execution
   * @returns {string[]}
   */
  getErrors() {
    const defaultErrorMessage =
      "Unexpected Error 3030. Please report this issue to the Averroes team support@averroes.ai";
    return this.hasErrors() ? this.errors : this.isSuccess() ? [] : [defaultErrorMessage];
  }

  /**
   *
   * @returns {string}
   */
  getProgress() {
    const percent = this.output.success_percent ?? this.progress;
    return percent > 0 ? `${percent}%` : "Failed";
  }

  /**
   * @returns {boolean}
   */
  canRerun() {
    return (
      this.triggeredBy === "Scheduled" &&
      (this.isPartialSuccess() ||
        this.status === ExecutionStatuses.FAILED ||
        this.status === ExecutionStatuses.SUCCEEDED)
    );
  }

  /**
   *
   * @returns {boolean}
   */
  isSuccess() {
    return (
      this.status === ExecutionStatuses.SUCCEEDED && (this.output.success_percent === 100 || this.progress === 100)
    );
  }

  /**
   *
   * @returns {boolean}
   */
  isInProgress() {
    return this.status === ExecutionStatuses.IN_PROGRESS;
  }

  /**
   *
   * @returns {boolean}
   */
  isPartialSuccess() {
    return this.output.success_percent && this.output.success_percent > 0 && this.output.success_percent < 100;
  }

  /**
   *
   * @returns {boolean}
   */
  isFailed() {
    return (this.output.success_percent && this.output.success_percent === 0) || this.progress < 100;
  }

  /**
   * @returns {string}
   */
  getUsedFile() {
    return this.triggeredBy === "Direct" ? this.sampleFileInfo.name : this.output.cloud_input_path;
  }
  updateExecution(payload) {
    return new Execution.fromApi({ ...this, ...payload });
  }

  static fromApi = ExecutionMapper;
}

function ExecutionMapper({
  id,
  name,
  organization,
  type,
  app_id,
  dataset_id,
  user_id,
  description,
  input,
  output,
  created_at,
  updated_at,
  started_at,
  terminated_at,
  status,
  progress,
  log_file_key,
  resources,
  task_type,
  triggered_by,
  dataset_info,
  sample_file_info,
  training_execution_info,
  source,
  errors,
}) {
  return new Execution(
    id,
    name,
    description,
    organization,
    resources,
    progress,
    status,
    type,
    task_type,
    source,
    triggered_by,
    log_file_key,
    input ?? {},
    output ?? {},
    dataset_info ?? {},
    training_execution_info ?? {},
    sample_file_info ?? {},
    errors ?? [],
    app_id,
    dataset_id,
    user_id,
    started_at,
    created_at,
    updated_at,
    terminated_at
  );
}
